// Scripting for distributor question blocks
document.addEventListener("DOMContentLoaded", function () {
    const faqAnswers = Array.from(document.querySelectorAll(".m-faqAnswer"));
    const faqToggles = Array.from(document.querySelectorAll(".m-faqToggle"));
    const catNavLinks = Array.from(
        document.querySelectorAll("a.o-categoryNav__link--faq")
    );

    if (faqAnswers.length > 0) {
        faqAnswers.forEach((faqAnswer) => {
            // Hide and remove preload class from question content
            faqAnswer.style.display = "none";
            faqAnswer.classList.remove("--preload");

            faqAnswer.addEventListener("click", function () {
                faqAnswer.style.display = "block";
            });
        });

        jQuery(".m-faqToggle").on("click", function () {
            jQuery(this).toggleClass("--toggled");
            let question = jQuery(".m-faqToggle__icon", this).data("question");
            jQuery("#content-" + question).slideToggle();
        });

        // Pure JavaScript method for faqToggle
        // faqToggles.forEach((faqToggle) => {
        //     faqToggle.addEventListener("click", function () {
        //         faqToggle.classList.toggle("--toggled");
        //         let question =
        //             faqToggle.querySelector(".m-faqToggle__icon").dataset
        //                 .question;
        //         let answer = document.querySelector(`#content-${question}`);
        //         if (answer.style.display != "none") {
        //             answer.style.display = "none";
        //         } else {
        //             answer.style.display = "block";
        //         }
        //     });
        // });

        catNavLinks.forEach((catNavLink) => {
            catNavLink.addEventListener("click", function (e) {
                e.preventDefault();

                let primaryNav = document.querySelector(".o-primaryNav");
                let navHeight = false;
                if (primaryNav) {
                    navHeight = primaryNav.offsetHeight;
                }
                if (!navHeight) {
                    navHeight =
                        document.querySelector(".o-simpleNav").offsetHeight;
                }
                let navLink = e.currentTarget.hash;

                let linkHeight = document.querySelector(navLink).offsetTop;
                let scrollAmount = linkHeight - navHeight;

                window.scrollTo({
                    top: scrollAmount,
                    left: 0,
                    behavior: "smooth",
                });
            });
        });
    }
});
